import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const i18n = new VueI18n({
  pluralizationRules: {
    EN(number) {
      return number === 1 ? 0 : 1;
    },
    EE(number) {
      return number === 1 ? 0 : 1;
    },
    LV(number) {
      if (number % 10 === 1 && number % 100 !== 11) {
        return 0;
      }
      if (number % 10 >= 2 && (number % 100 < 10 || number % 100 >= 20)) {
        return 1;
      }
      return 2;
    },
    RU(number) {
      if (number % 10 === 1 && number % 100 !== 11) {
        return 0;
      }
      if (number % 10 >= 2 && number % 10 <= 4 && (number % 100 < 10 || number % 100 >= 20)) {
        return 1;
      }
      return 2;
    },
    LT(number) {
      if (number % 10 === 1 && number % 100 !== 11) {
        return 0;
      }
      if (number % 10 >= 2 && (number % 100 < 10 || number % 100 >= 20)) {
        return 1;
      }
      return 2;
    },
  },
});

export default i18n;
